import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const iosLogin = (signemail, token) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
          method : "GET",
          url :  api_url + "/IosLogin",
          params : {"signemail": signemail, "token": token},
          headers:  { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const androidLogin = (signemail, token) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/AndroidLogin",
          params : {"signemail": signemail, "token": token},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}